import React from 'react';
import { Link } from 'react-router-dom';
import './supportmission.css';

function SupportMission() {
  return (
    <div className="mission-container">
      {/* Hero Section */}
      <div className="mission-hero">
        <div className="hero-content">
          <h1 className="hero-title animate-fade-in">Support Our Mission</h1>
          <p className="hero-subtitle animate-fade-in-delay">
            Join us in making a difference. Your support helps us create positive change in the world.
          </p>
        </div>
        <div className="hero-wave"></div>
      </div>

      {/* Mission Statement */}
      <div className="mission-statement animate-slide-up">
        <div className="statement-content">
          <h2>Our Commitment to Sri Lanka</h2>
          <p>
          At Community Eye Care, we believe that vision is a right not a privilege. As of more than 80% people of Sri Lanka never had eye examination one time in their life. Resultantly blindness rate in Sri Lanka is 1.7% in above 40 years of age. More than 50% population cannot afford eye care goods and services. Most parts of Sri Lanka even today People has to travel more than 50km to get eye care services.
          So we believe on mantra: 3A: increase Awareness on eye care, make eye care Available, provide eye care services affordable.  <br />
        <br /><b>What we do ?</b> <br /><br />

          1. Train eye care personals, teachers, health care personals( medical doctors, nurses, midwife, public health inspectors), volunteers on eye care. <br />
          2. Conduct eye care centers, eye care awareness, eye camps for adults and children ( reaching to unreached)< br />
          3. Providing affordable or free eye care services & goods<br />
          4. Uplifting life of visually impaired< br /> 
          5. Lobbying for developing policies and standards on  eye care
          </p>

          {/* <div className="mission-stats">
            <div className="stat-item-s animate-card">
              <div className="stat-number" data-count="250">200+ successful programs</div>
              <div className="stat-label">Community Projects Completed</div> 
            </div>
            <div className="stat-item-s animate-card-delay-1">
              <div className="stat-number" data-count="25">25 districts empowered</div>
              <div className="stat-label">Islandwide Impact</div>
            </div>
            <div className="stat-item-s animate-card-delay-2">
              <div className="stat-number" data-count="1.2">Over 35000 lives touched</div>
              <div className="stat-label">Sri Lankans Benefited</div>
            </div>
          </div> */}

          
        </div>
      </div>


      {/* Ways to Support */}
      <div className="support-options">
        <h2 className="section-title animate-fade-in">Ways You Can Help</h2>
        <div className="options-grid">
        <div className="option-card animate-card">
          <div className="card-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
            </svg>
          </div>
          <h3>Get Involved</h3>
          <p>
            Be a part of something meaningful. Join our awareness drives, community efforts,
            or volunteer programs to help us create lasting change in Sri Lanka.
          </p>
          <Link to="/joinus"> <button className="card-button">Get Involved</button></Link>
        </div>


          <div className="option-card animate-card-delay-1">
            <div className="card-icon">
              <svg viewBox="0 0 24 24">
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
              </svg>
            </div>
            <h3>Volunteer</h3>
            <p>
              Join our team of dedicated volunteers and contribute your time and skills 
              to make a tangible difference.
            </p>
            <Link to="/joinus"> <button className="card-button">Join Now</button></Link>
          </div>

          <div className="option-card animate-card-delay-2">
            <div className="card-icon">
              <svg viewBox="0 0 24 24">
                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
              </svg>
            </div>
            <h3>Partner With Us</h3>
            <p>
              Are you a business or organization? Explore partnership opportunities 
              to amplify our collective impact.
            </p>
            <Link to="/joinus"><button className="card-button">Partner Now</button></Link>
          </div>
        </div>
      </div>



      {/* Call to Action */}
      <div className="mission-cta animate-fade-in">
        <div className="cta-content">
          <h2>Ready to Make a Difference?</h2>
          <p>
            Every contribution matters. Join our community of changemakers today and 
            be part of something bigger than yourself.
          </p>
          <div className="cta-buttons">
            <Link to="/contactus"><button className="cta-button secondary">Contact Us</button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportMission;